import React, { useState, useEffect } from 'react';

const MicrophoneSelector: React.FC = () => {
  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string>(() => {
    // Initialize from localStorage
    return localStorage.getItem('selectedMicrophoneDeviceId') || '';
  });

  useEffect(() => {
    // Ask for microphone permission to get device labels in most browsers
    // (You might want to handle permission errors more gracefully in production)
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        // Now that permission is granted, enumerate all devices
        navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
          const audioInputDevices = deviceInfos.filter(
            (deviceInfo) => deviceInfo.kind === 'audioinput'
          );
          setDevices(audioInputDevices);

          // If localStorage had a selected device but it's not valid anymore,
          // you could reset it here, or handle that logic in the UI.
        });
      })
      .catch((err) => {
        console.error('Microphone permission denied:', err);
      });
  }, []);

  // Whenever user changes device, update state and localStorage
  const handleDeviceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newDeviceId = event.target.value;
    setSelectedDeviceId(newDeviceId);
    localStorage.setItem('selectedMicrophoneDeviceId', newDeviceId);
  };

  return (
    <div>
      <label htmlFor="microphone-select">Choose a microphone:</label>
      <select
        id="microphone-select"
        value={selectedDeviceId}
        onChange={handleDeviceChange}
      >
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label || `Microphone ${device.deviceId}`}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MicrophoneSelector;
